export const FREE_TRIAL_PAGE_SLUG = "free-trial";
